import { BnplBand } from "@/components/marketplace/bnpl/bnpl-band"

// The one place the whole offer is stated, on every page, immediately above the
// footer. It sits in the chrome rather than in any page body so the thread is
// literally the same object everywhere instead of near-copies that drift — which
// is why it is the listing band's own component and not a second one beside it.
//
// One sentence, not a row of lockups. Four of them side by side read as
// «% de interés · hoy $0 · nelo tarjeta de crédito · nelo × 4 quincenas», which is
// not a sentence in any language: two of the four dropped the wordmark into
// running copy, and the reader had to reassemble a claim out of fragments.
export const ClaimBand = () => <BnplBand containment="bleed" />
